module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/ko/6-bd453a22def9fbdadc9cf209caf95059.jpg";